export function associationKey(object) {
    if (typeof object === "string" ||
        typeof object === "number" ||
        typeof object === "boolean") {
        return object;
    }
    return object.associationKey;
}
